import store from 'store2'

export const useLocalStorage = <T>(key: string, defaultValue: T): [T, (val: T) => void] => {
  const stored = store.get(key, defaultValue)
  const setStored = (val: T) => store.set(key, val)
  return [stored, setStored]
}

export default useLocalStorage